<div class="inline-flex items-center justify-center rounded-full overflow-hidden flex-shrink-0"
  [style.width.px]="px" [style.height.px]="px">
  @if(photoUrl) {
    <img [src]="photoUrl" [alt]="name" class="w-full h-full object-cover" loading="lazy" />
  } @else {
    <div class="w-full h-full flex items-center justify-center text-white font-semibold"
      [style.background-color]="bgColor"
      [style.font-size.px]="px * 0.38">
      {{ initials }}
    </div>
  }
</div>
